import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { StyledQuestionIconWrap } from "./styles";

type Props = {
    onClick: VoidFunction;
};

const EducationBarIconButton = ({ onClick }: Props): ReactElement => {
    const translate = useTranslation();

    return (
        <Tooltip
            placement={"bottom"}
            content={translate("page.title.education.icon.tooltip")}
        >
            <StyledQuestionIconWrap>
                <IconButton
                    iconColor={colorsPalettes.blue[400]}
                    type="flat"
                    iconSize="sm"
                    iconName="learning-hat"
                    onClick={onClick}
                />
            </StyledQuestionIconWrap>
        </Tooltip>
    );
};

export default EducationBarIconButton;
